import { SNCR_STORAGE } from "../constants";
import type { SncrAuthResult } from "../types";

export function getAccessToken(): string | null {
  return sessionStorage.getItem(SNCR_STORAGE.accessToken);
}

export function setAccessToken(token: string): void {
  sessionStorage.setItem(SNCR_STORAGE.accessToken, token);
}

export function clearAccessToken(): void {
  sessionStorage.removeItem(SNCR_STORAGE.accessToken);
}

export function getLastAuthResult(): SncrAuthResult | null {
  const value = sessionStorage.getItem(SNCR_STORAGE.lastResult);
  return value === "success" || value === "error" ? value : null;
}

export function setLastAuthResult(result: SncrAuthResult): void {
  sessionStorage.setItem(SNCR_STORAGE.lastResult, result);
}

export function clearLastAuthResult(): void {
  sessionStorage.removeItem(SNCR_STORAGE.lastResult);
}

export function getExchangeLock(sessionId: string): string | null {
  return sessionStorage.getItem(`${SNCR_STORAGE.exchangeLock}:${sessionId}`);
}

export function setExchangeLock(
  sessionId: string,
  state: "pending" | "done" | "error",
): void {
  sessionStorage.setItem(`${SNCR_STORAGE.exchangeLock}:${sessionId}`, state);
}
